(() => {
  const selectors = {
    hero: '.js-hero',
    heroSwiper: '.js-hero .swiper',
    heroSlide: '.hero__slide',
    slidePagination: '.js-slide-pagination',
    slideButtonPrev: '.js-slide-button-prev',
    slideButtonNext: '.js-slide-button-next',
    slidePaginationBullet: '.js-slide-pagination-bullet',
    stickyButton: '.hero__slide-button.float',
    stickyButtonWrapper: '.hero__slide-button-wrapper',
    footer: '.footer',
  };

  const heroElement = document.querySelector(selectors.hero);
  if (!heroElement) return;

  const slidesCount = parseInt(heroElement.dataset.slidesCount) || 0;
  const slides = heroElement.querySelectorAll(selectors.heroSlide);

  const initStickyButtons = () => {
    const button = heroElement.querySelector(selectors.stickyButton);
    if (!button) return;

    let atTop = true,
      atBottom = false;

    const update = () => {
      if (atTop || atBottom) {
        // button.closest(selectors.stickyButtonWrapper).removeAttribute('style');
        button.classList.remove('fixed');
      } else if (!button.classList.contains('fixed')) {
        // button.closest(selectors.stickyButtonWrapper).style.minHeight = button.clientHeight + 'px';
        button.classList.add('fixed');
      }
    };

    new IntersectionObserver(
      ([e]) => {
        atTop = e.isIntersecting;
        update();
      },
      { root: null, rootMargin: '0px 0px 45px 0px', threshold: 0.01 }
    ).observe(heroElement.querySelector(selectors.stickyButtonWrapper));

    const footerElement = document.querySelector(selectors.footer);
    if (footerElement) {
      new IntersectionObserver(
        ([e]) => {
          atBottom = e.isIntersecting;
          update();
        },
        { root: null, rootMargin: '0px', threshold: 0.01 }
      ).observe(footerElement);
    }
  };

  if (slidesCount <= 1 || slides.length <= 1) {
    heroElement.classList.add('hero--single-slide');

    initStickyButtons();
    document.addEventListener('shopify:section:load', (e) => {
      initStickyButtons();
    });

    return;
  }

  const { autoplay, speed, delay, loop, pause_on_hover } = heroElement.dataset;

  const heroSwiper = new Swiper(selectors.heroSwiper, {
    speed: parseInt(speed) || 2000,
    autoplay: autoplay === 'true' ? {
      enabled: true,
      delay: parseInt(delay) || 4000,
      disableOnInteraction: true,
      pauseOnMouseEnter: pause_on_hover === 'true'
    } : false,
    loop: loop === 'true',
    effect: 'creative',
    creativeEffect: {
      prev: { translate: [0, 0, -400] },
      next: { translate: ['100%', 0, 0] },
    },
  });

  document.querySelectorAll(selectors.slidePaginationBullet).forEach((bullet, index) => {
    bullet.addEventListener('click', () => {
      heroSwiper.slideTo(index);
    });
  });

  document.querySelectorAll(selectors.slideButtonPrev).forEach((button, index) => {
    button.addEventListener('click', () => {
      heroSwiper.slidePrev();
    });
  });

  document.querySelectorAll(selectors.slideButtonNext).forEach((button, index) => {
    button.addEventListener('click', () => {
      heroSwiper.slideNext();
    });
  });

  const updateActiveBullet = () => {
    const activeIndex = heroSwiper.realIndex;

    document.querySelectorAll(selectors.slidePaginationBullet).forEach((bullet) => {
      bullet.classList.remove('active');
    });

    const activeBullet = document.querySelectorAll(
      `${selectors.slidePaginationBullet}[data-slide-index="${activeIndex}"]`
    );
    activeBullet.forEach((bullet) => {
      bullet.classList.add('active');
    });
  };

  heroSwiper.on('slideChange', updateActiveBullet);
  heroSwiper.on('slideChangeTransitionEnd', updateActiveBullet);

  const firstBullet = document.querySelector(`${selectors.slidePaginationBullet}[data-slide-index="0"]`);
  if (firstBullet) {
    firstBullet.classList.add('active');
  }
})();
